exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-companyDetails-SubscriptionPreferences-isnCheckbox{margin-bottom:10px}.src-components-companyDetails-SubscriptionPreferences-isnCheckbox .src-components-companyDetails-SubscriptionPreferences-checkboxLabel{font-weight:bold}.src-components-companyDetails-SubscriptionPreferences-disabled{cursor:default}.src-components-companyDetails-SubscriptionPreferences-enabled{cursor:pointer}", ""]);

// exports
exports.locals = {
	"isnCheckbox": "src-components-companyDetails-SubscriptionPreferences-isnCheckbox",
	"checkboxLabel": "src-components-companyDetails-SubscriptionPreferences-checkboxLabel",
	"disabled": "src-components-companyDetails-SubscriptionPreferences-disabled",
	"enabled": "src-components-companyDetails-SubscriptionPreferences-enabled"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/companyDetails/SubscriptionPreferences/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/companyDetails/SubscriptionPreferences/styles.scss
// module chunks = 1